import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

import { TaskService } from '../../../../core/timeline';
import { TaskEntity } from '../models';
import { TaskEntityType } from '../enums';

@Component({
  selector: 'kt-format-task-entities',
  templateUrl: './format-task-entities.component.html',
  styleUrls: ['./format-task-entities.component.scss'],
})
export class FormatTaskEntitiesComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  // for HTML template use
  TaskEntityType = TaskEntityType;
  //
  entitiesMap = {};
  entitiesMapEntries = [];
  @Input() entities$: BehaviorSubject<Partial<TaskEntity>[]>;

  constructor(private taskService: TaskService) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.entities$.subscribe((entities) => {
        Object.values(TaskEntityType).forEach((type) => (this.entitiesMap[type] = []));
        entities?.forEach((entity) => this.entitiesMap[entity.entity_type]?.push(entity));

        this.entitiesMapEntries = Object.entries(this.entitiesMap);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  openEntityOffcanvas(type: TaskEntityType, id: number): void {
    document.getElementById('kt_entity_details_offcanvas')?.classList.add('offcanvas-on');
    document.getElementById('hide-overlay')?.setAttribute('id', 'show-overlay');

    this.taskService?.newEntity.next({ type, id });
  }
}
